import clubsModule from "./type";
import eventsModule from "../../../events/module/store/type";

const getters = {
    [clubsModule.getters.membershipClubsRequests]: state => clubId => {
        return state.membershipClubsRequests[clubId] || false
    },
    [clubsModule.getters.club]: state => {
        return state.source.club
    },
    [clubsModule.getters.type]: state => {
        return state.type
    },
    [clubsModule.getters.clubTransitionEnabled]: state => {
        return state.clubTransitionEnabled
    },
    [clubsModule.getters.clubDates]: state => {
        return state.clubDates
    },
    [clubsModule.getters.clubIdsByDate]: state => date => {
        // let existedDateIndex = state.clubDates.findIndex(v => v.date === date)
        // if (existedDateIndex === -1) {
        //     return []
        // }
        // let existedEntry = state.clubDates[existedDateIndex]
        // let lowRangeClubIds = existedEntry.clubs_range_low.map(club => {
        //     return club.id
        // })
        // return lowRangeClubIds
    },
}

export default getters
